import { useEffect, useState } from "react";
import InnerHTML from 'dangerously-set-html-content'

import KonamiCode from './mini-games/KonamiCode';
import Popups from './mini-games/Popups.js';
import Paint from './mini-games/Paint.js';

import "./MiniGamesBox.css"

function MiniGamesBox(props) {

  const SocketConnection = props.SocketConnection;

  const [miniGame, setMiniGame] = useState(null);
  const [isMinigameRunning, setIsMinigameRunning] = useState(false);

  const handleStartMiniGame = (name) => {
    console.log(`Asked to start mini game: ${name}`);
    setIsMinigameRunning(true);
    setMiniGame(name);
    if (document.querySelector('div.videofeed')) {
      document.querySelector('div.videofeed').style.display = 'none';
    }
  };
  const handleCloseMiniGame = () => {
    console.log(`Asked to close mini game`);
    setIsMinigameRunning(false);
    setMiniGame(null);
    if (document.querySelector('div.videofeed')) {
      document.querySelector('div.videofeed').style.display = 'block';
    }
  };

  useEffect(() => {
    SocketConnection.startMinigameHandler = handleStartMiniGame;
    SocketConnection.closeMinigameHandler = handleCloseMiniGame;
  }, []);

    return (
      <div className="minigames-box">
        { isMinigameRunning
          && miniGame === 'konami'
          && <KonamiCode player={props.player} SocketConnection={SocketConnection} MirrorConnection={props.MirrorConnection}/>
        }
        {isMinigameRunning
          && miniGame === 'popups'
          && <Popups player={props.player} SocketConnection={SocketConnection} MirrorConnection={props.MirrorConnection} />
        }
        {isMinigameRunning
          && miniGame === 'paint'
          && <Paint player={props.player} SocketConnection={SocketConnection} MirrorConnection={props.MirrorConnection} />
        }

        
        {/* <KonamiCode SocketConnection={SocketConnection} /> */}
        {/* <Popups player={props.player} SocketConnection={SocketConnection} MirrorConnection={props.MirrorConnection} /> */}
      </div>
    );
  }
  
  export default MiniGamesBox;